export default __webpack_public_path__ + "static/media/gstreets.6dfc927c.jpg";